import { Component, OnInit } from '@angular/core';
import { BasketService } from '../basket.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { PurchaseTransaction } from '../purchase-transaction';

@Component({
  selector: 'app-shipping',
  templateUrl: './shipping.component.html',
  styleUrls: ['./shipping.component.css']
})
export class ShippingComponent implements OnInit {
  shippingCosts;
  shippingAddress;
  shippingRate;
  subtotal;
  shipping;
  displayRate;
  loading = false;
  errorMsg= '';

  //public purchase$: Observable<PurchaseTransaction>;

  constructor(
    private basketService: BasketService,
    private router: Router
  ) { }

  ngOnInit() {
    // don't bother doing anything if no products
    if (this.basketService.getNumberOfItems() === 0) {
       this.router.navigateByUrl('/basket');
    }
    // cost before shipping
    this.subtotal = this.basketService.getTotalCost();

    if (this.subtotal === 0) {
      this.router.navigateByUrl('/');
    }
    this.shipping = this.basketService.getShippingCost();
    // now calculate shipping
    this.shippingCosts = this.basketService.getShippingPrices();
    //this.shippingAddress = this.basketService.getShippingAddress();
    this.shippingRate = this.basketService.getShippingRate();
    this.displayRate = this.shippingCosts[this.shippingRate].type;
   }


   purchase() {
     this.loading = true;
     this.basketService.purchase().
       subscribe(data => {
         this.basketService.serverData = data;
         this.router.navigateByUrl('/purchase');
      },
      err => {
        this.errorMsg = err;
        this.loading = false;
      },
      () => {
        console.log('complete.')
      });
     
   }
}